import React, { useState, useRef, useEffect } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination, Autoplay } from "swiper/modules";
import "./Team.css";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import { useTranslation } from "react-i18next";

// Import review logos
import ascentiaLogo from "../../assets/ReviewLogos/ascentia.png";
import comexLogo from "../../assets/ReviewLogos/Comexlogo.png";
import otikaLogo from "../../assets/ReviewLogos/logo-Otika-Services-1.png";
import reviewLogo1 from "../../assets/ReviewLogos/image (4).png";
import reviewLogo2 from "../../assets/ReviewLogos/image (5).png";
import reviewLogo3 from "../../assets/ReviewLogos/image (6).png";
import windsorLogo from "../../assets/companiesServed/windsor_logo_invitation (1).jpg";

function useReveal(options = { threshold: 0.18, rootMargin: "0px 0px -10% 0px" }) {
  const ref = useRef(null);
  const [inView, setInView] = useState(false);

  useEffect(() => {
    if (!ref.current || inView) return;
    if (!("IntersectionObserver" in window)) {
      setInView(true);
      return;
    }
    const io = new IntersectionObserver(([entry]) => {
      if (entry.isIntersecting) {
        setInView(true);
        io.disconnect();
      }
    }, options);
    io.observe(ref.current);
    return () => io.disconnect();
  }, [inView, options]);

  return [ref, inView];
}

const testimonials = [
  {
  id: 2,
  tName: "team.testimonials.2.name",
  tTitle: "team.testimonials.2.title",
  tCompany: "team.testimonials.2.company",
  tContent: "team.testimonials.2.content",
  tIndustry: "team.testimonials.2.industry",
  name: "Arnaud Bellemare",
  title: "Property Manager",
  company: "Ascentia",
  content:
    "Very great company, if not the best in the field.",
  rating: 5,
  industry: "Property Management",
  logo: ascentiaLogo,
},
{
  id: 3,
  tName: "team.testimonials.3.name",
  tTitle: "team.testimonials.3.title",
  tCompany: "team.testimonials.3.company",
  tContent: "team.testimonials.3.content",
  tIndustry: "team.testimonials.3.industry",
  name: "Johnny Makris",
  title: "CEO",
  company: "Loc Equip",
  content:
    "Fantastic service great team! Vision Security has been our trusted partner for equipment site protection. Their guards are vigilant, professional, and understand the unique challenges of our industry.",
  rating: 5,
  industry: "Construction & Equipment",
  logo: reviewLogo3,
},
{
  id: 4,
  tName: "team.testimonials.4.name",
  tTitle: "team.testimonials.4.title",
  tCompany: "team.testimonials.4.company",
  tContent: "team.testimonials.4.content",
  tIndustry: "team.testimonials.4.industry",
  name: "Celina Bouatmane",
  title: "Director",
  company: "Otika Services",
  content:
    "Nous travaillons avec cette compagnie, et leur professionnalisme est irréprochable. Nous n'avons jamais regretté de les avoir choisis. De plus, notre collaboration avec l'agent Mamadou est exceptionnelle : il est sérieux, compétent, et démontre un grand professionnalisme dans son travail.",
  rating: 5,
  industry: "Professional Services",
  logo: otikaLogo,
},
{
  id: 5,
  tName: "team.testimonials.5.name",
  tTitle: "team.testimonials.5.title",
  tCompany: "team.testimonials.5.company",
  tContent: "team.testimonials.5.content",
  tIndustry: "team.testimonials.5.industry",
  name: "Edouard Wanadi",
  title: "Law enforcement Officer",
  company: "Royal Canadian Mounted Police",
  content:
    "What truly stopd out was their unwavering commitment to customer satisfaction. They went above and beyond to adress all my concerns and questions providing comprehensive solitions that left no room for doubt or misunderstanding.This company has gained my full respect and support as they have given me",
  rating: 5,
  industry: "Law Enforcement",
  logo: reviewLogo2,
},
{
  id: 6,
  tName: "team.testimonials.6.name",
  tTitle: "team.testimonials.6.title",
  tCompany: "team.testimonials.6.company",
  tContent: "team.testimonials.6.content",
  tIndustry: "team.testimonials.6.industry",
  name: "Kobe Archer",
  title: "Master Corporal",
  company: "Canadian Armed Forces",
  content:
    "Very professional atmosphere from the employees and management. Vision Security maintains the high standards we expect and their team integrates seamlessly with our security protocols.",
  rating: 5,
  industry: "Government & Defense",
  logo: reviewLogo1,
},
{
  id: 7,
  tName: "team.testimonials.7.name",
  tTitle: "team.testimonials.7.title",
  tCompany: "team.testimonials.7.company",
  tContent: "team.testimonials.7.content",
  tIndustry: "team.testimonials.7.industry",
  name: "Leilani Baja",
  title: "Director of Finances & Operations",
  company: "Le Windsor",
  content:
    "Vision Sécurité Inc. is a group of professional and knowledgeable agents. They are punctual, alert and well versed in the event industry. They have been a great addition to our team and would highly recommend them.",
  rating: 5,
  industry: "Event Venue",
  logo: windsorLogo,
},
{
  id: 8,
  tName: "team.testimonials.8.name",
  tTitle: "team.testimonials.8.title",
  tCompany: "team.testimonials.8.company",
  tContent: "team.testimonials.8.content",
  tIndustry: "team.testimonials.8.industry",
  name: "Martin Riviere",
  title: "Event Coordinator",
  company: "Comexposium",
  content:
    "Just wrapped up a great event with this company. Happy with all security guards they have sent with us. Recommend.",
  rating: 5,
  industry: "Event Services",
  logo: comexLogo,
},
{
  id: 9,
  tName: "team.testimonials.9.name",
  tTitle: "team.testimonials.9.title",
  tCompany: "team.testimonials.9.company",
  tContent: "team.testimonials.9.content",
  tIndustry: "team.testimonials.9.industry",
  name: "Athena Nikolakakis",
  title: "CPA Auditor Controller",
  company: "GoTransport",
  content:
    "We've been working with Vision Sécurité for our company's security needs and have been very pleased with their service so far. The team is professional, responsive, and reliable. Communication is always clear and they've been proactive in ensuring everything runs smoothly.Thank you to Renzo and the entire team for your continued support, highly recommend!",
  rating: 5,
  industry: "Transportation & Logistics"
}

];

const Team = () => {
  const { t } = useTranslation();
  const [headRef, headIn] = useReveal();
  const [carouselRef, carouselIn] = useReveal();
  const [swiperInstance, setSwiperInstance] = useState(null);
  const [isBeginning, setIsBeginning] = useState(true);
  const [isEnd, setIsEnd] = useState(false);

  const handlePrevSlide = () => swiperInstance && swiperInstance.slidePrev();
  const handleNextSlide = () => swiperInstance && swiperInstance.slideNext();

  const renderStars = (rating) =>
    Array.from({ length: 5 }, (_, index) => (
      <svg
        key={index}
        className="team__star"
        viewBox="0 0 24 24"
        fill={index < rating ? "currentColor" : "none"}
        stroke="currentColor"
        strokeWidth="2"
      >
        <polygon points="12,2 15.09,8.26 22,9.27 17,14.14 18.18,21.02 12,17.77 5.82,21.02 7,14.14 2,9.27 8.91,8.26" />
      </svg>
    ));

  // gettext helpers with graceful fallback to the inline values
  const getName =   (it) => (it.tName    ? t(it.tName)    : it.name);
  const getTitle =  (it) => (it.tTitle   ? t(it.tTitle)   : it.title);
  const getCompany =(it) => (it.tCompany ? t(it.tCompany) : it.company);
  const getContent =(it) => (it.tContent ? t(it.tContent) : it.content);
  const getIndustry=(it) => (it.tIndustry? t(it.tIndustry): it.industry);

  return (
    <section className="team" id="team" aria-labelledby="team-heading">
      <div className="team__container">
        <header
          ref={headRef}
          className={`team__header reveal reveal--up ${headIn ? "in" : ""}`}
        >
          <div className="team__header-content">
            <div className="team__title-group">
              <h2
                id="team-heading"
                className="team__heading reveal-item"
                style={{ transitionDelay: "80ms" }}
              >
                {t("team.heading", { defaultValue: "What People Say About Vision" })}
              </h2>
              <div
                className="team__accent-line reveal-item"
                style={{ transitionDelay: "120ms" }}
              />
            </div>
            <p
              className="team__subhead reveal-item"
              style={{ transitionDelay: "170ms" }}
            >
              {t("team.subhead", {
                defaultValue:
                  "From event organizers and property managers to our frontline officers, these first-hand stories reflect our commitment to safety, clear communication, and respectful service."
              })}
            </p>
            <div
              className="team__nav-controls reveal-item"
              style={{ transitionDelay: "220ms" }}
            >
              <button
                className="team__nav-arrow team__nav-prev"
                onClick={handlePrevSlide}
                disabled={isBeginning}
                aria-label={t("team.prev", { defaultValue: "Previous testimonial" })}
              >
                <svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
                  <path d="M15.41 7.41L14 6l-6 6 6 6 1.41-1.41L10.83 12z" />
                </svg>
              </button>
              <button
                className="team__nav-arrow team__nav-next"
                onClick={handleNextSlide}
                disabled={isEnd}
                aria-label={t("team.next", { defaultValue: "Next testimonial" })}
              >
                <svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
                  <path d="M10 6L8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z" />
                </svg>
              </button>
            </div>
          </div>
        </header>

        <div
          ref={carouselRef}
          className={`team__carousel-wrap reveal reveal--up ${carouselIn ? "in" : ""}`}
        >
          <Swiper
            className="team__carousel"
            modules={[Navigation, Pagination, Autoplay]}
            onSwiper={(swiper) => {
              setSwiperInstance(swiper);
              setIsBeginning(swiper.isBeginning);
              setIsEnd(swiper.isEnd);
            }}
            onSlideChange={(swiper) => {
              setIsBeginning(swiper.isBeginning);
              setIsEnd(swiper.isEnd);
            }}
            navigation={false}
            pagination={{
              clickable: true,
              bulletClass: "team__bullet",
              bulletActiveClass: "team__bullet--active",
            }}
            autoplay={{
              delay: 5000,
              disableOnInteraction: false,
              pauseOnMouseEnter: true,
            }}
            spaceBetween={0}
            slidesPerView={1}
            loop={testimonials.length > 1}
            centeredSlides={true}
            watchOverflow={true}
            breakpoints={{
              768: { 
                slidesPerView: 2, 
                spaceBetween: 30,
                centeredSlides: false,
              },
              1200: { 
                slidesPerView: 3, 
                spaceBetween: 40,
                centeredSlides: false,
              },
            }}
          >
            {testimonials.map((it, index) => (
              <SwiperSlide key={it.id}>
                <div
                  className="team__card reveal-item"
                  style={{ transitionDelay: `${300 + (index % 3) * 100}ms` }}
                >
                  <div className="team__content">
                    <div className="team__rating">{renderStars(it.rating)}</div>

                    <blockquote className="team__quote">“{getContent(it)}”</blockquote>

                    <div className="team__author">
                      <div className="team__author-info">
                        <div className="team__name">{getName(it)}</div>
                        <div className="team__title">{getTitle(it)}</div>
                        <div className="team__company">{getCompany(it)}</div>
                        <div className="team__industry-tag">
                          <span className="team__industry-text">{getIndustry(it)}</span>
                        </div>
                      </div>
                      {it.logo && (
                        <div className="team__logo-box">
                          <img
                            src={it.logo}
                            alt={`${getCompany(it)} logo`}
                            className="team__company-logo"
                          />
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </SwiperSlide>
            ))}
          </Swiper>
        </div>

    
      </div>
    </section>
  );
};

export default Team;